import _ from 'lodash';
import {
  SET_RX,
  UPDATE_USER_SHIPPING_INFO,
  UPDATE_USER_PAYMENT_INFO,
  UPDATE_USER_CVC,
  UPDATE_DEFAULT_PAYMENT,
  UPDATE_PAYMENT_OPTIONS,
  SET_JWT,
  UPDATE_TAX_DISPLAY,
} from '../actions/userInformation/types';

import {
  AUTH_NET_TOKENIZATION,
  REMOVE_BEARER,
  REMOVE_CVC,
} from '../actions/order/types';

import { setOtherGADimension } from '../gtmMetrics';

const initState = {};

const userInfo = (state = initState, action) => {
  switch (action.type) {
    case SET_RX: {
      const { payload } = action;

      const {
        customer: {
          practiceGuid = '',
          practiceId = '',
          practicePlatformTypeId = 5,
        } = {},
        prescription: {
          vetPracticeName: practiceName = '',
          prescriptionId = '',
        } = {},
        product: {
          productName: parentProductName = '',
          sku: childSKU = '',
        } = {},
        priceInformation: {
          price: productPrice = 0.0,
          shipping: shippingCost = 0.0,
          tax = 0.0,
        } = {},
        paymentOptions = [],
      } = payload;

      const pharmacyType =
        practicePlatformTypeId === 5 ? 'Covetrus Houston' : 'RR';
      setOtherGADimension({
        practiceGuid,
        practiceId,
        practiceName,
        pharmacyType,
        practicePlatformTypeId,
        parentProductName,
        brand: '',
        childSKU,
        productPrice,
        shippingCost,
        tax,
        orderTotal: productPrice + shippingCost + tax,
        nbrofCardsonFile: paymentOptions.length,
        prescriptionId,
      });

      return {
        ...state,
        ..._.merge(payload, {
          product: {
            shippingLabel: 'Shipping',
          },
        }),
      };
    }
    case SET_JWT:
      return { ...state, authentication: action.payload };

    case UPDATE_USER_SHIPPING_INFO:
      return {
        ...state,
        customer: {
          ...state.customer,
          shippingAddress: {
            ...(action.payload.street1 && action.payload.city
              ? _.omit(action.payload, 'fullName')
              : state.customer.shippingAddress),
          },
        },
      };

    case UPDATE_USER_PAYMENT_INFO:
      return {
        ...state,
        defaultPaymentOption: {
          ...state.defaultPaymentOption,
          paymentToken: null,
          creditCardNumber: action.payload.creditCardNumber,
          isExpired: false,
          expirationMonth: action.payload.expirationMonth,
          expirationYear: action.payload.expirationYear,
          cvcNumber: null,
          name: action.payload.nameOnCard,
          paymentProfileId: action.payload.paymentProfileId,
        },
        customer: {
          ...state.customer,
          billingAddress: !action.payload.billingAddress
            ? null
            : {
                ...(state.customer && state.customer.billingAddress
                  ? state.customer.billingAddress
                  : {}),
                street1: action.payload.billingAddress.street1,
                street2: action.payload.billingAddress.street2,
                city: action.payload.billingAddress.city,
                state: action.payload.billingAddress.state,
                postalCode: action.payload.billingAddress.postalCode,
                phoneNumber: action.payload.billingAddress.phoneNumber,
                emailAddress: action.payload.billingAddress.emailAddress,
              },
        },
      };

    case UPDATE_PAYMENT_OPTIONS: {
      const newDefaultPaymentOption = {
        name: action.payload.nameOnCard,
        creditCardNumber: action.payload.creditCardNumber,
        isExpired: false,
        expirationMonth: action.payload.expirationMonth,
        expirationYear: action.payload.expirationYear,
        cvcNumber: action.payload.ccSecurityCode,
        paymentToken: null,
        paymentProfileId: action.payload.paymentProfileId || 0,
        paymentGateway: 'AUTH_NET_CIM',
      };

      let paymentOptions = null;
      if (state.paymentOptions === null) {
        paymentOptions = [newDefaultPaymentOption];
      } else {
        paymentOptions = [...state.paymentOptions, newDefaultPaymentOption];
      }

      let newBillingAddress = null;
      if (action.payload.distinctBillingAddress) {
        newBillingAddress = {
          fullName: action.payload.billingAddress.fullName,
          firstName: action.payload.billingAddress.fullName.split(/\s(.+)/)[0],
          lastName: action.payload.billingAddress.fullName.split(/\s(.+)/)[1],
          city: action.payload.billingAddress.city,
          postalCode: action.payload.billingAddress.postalCode,
          state: action.payload.billingAddress.state,
          street1: action.payload.billingAddress.street1,
          street2: action.payload.billingAddress.street2,
        };
      } else {
        newBillingAddress =
          state.customer.billingAddress && state.customer.billingAddress.guid
            ? state.customer.billingAddress
            : state.customer.shippingAddress;
      }

      return {
        ...state,
        paymentOptions,
        defaultPaymentOption: newDefaultPaymentOption,
        customer: { ...state.customer, billingAddress: newBillingAddress },
      };
    }
    case UPDATE_USER_CVC:
      return {
        ...state,
        defaultPaymentOption: {
          ...state.defaultPaymentOption,
          cvcNumber: action.payload.ccSecurityCode,
        },
      };

    case UPDATE_DEFAULT_PAYMENT:
      return {
        ...state,
        defaultPaymentOption: {
          ...action.payload,
        },
      };

    case UPDATE_TAX_DISPLAY: {
      return {
        ...state,
        priceInformation: {
          ...state.priceInformation,
          tax: action.payload.taxUpdate.taxTotal,
        },
      };
    }
    case REMOVE_BEARER:
      return {
        ...state,
        authentication: '',
      };

    case REMOVE_CVC:
      return {
        ...state,
        defaultPaymentOption: {
          ...state.defaultPaymentOption,
          cvcNumber: '',
        },
      };

    case AUTH_NET_TOKENIZATION:
      return {
        ...state,
        customer: {
          ...state.customer,
        },
        defaultPaymentOption: {
          ...state.defaultPaymentOption,
          paymentToken: action.payload,
          creditCardNumber: '',
          expirationYear: '',
          expirationMonth: '',
        },
        payment: {
          opaqueData: action.payload,
        },
      };

    default:
      return state;
  }
};

export default userInfo;



// WEBPACK FOOTER //
// ./src/reducers/userInfo.js